import { useEffect } from 'react';

export default function PageTitle({ title = undefined }) {
  useEffect(() => {
    if (title) document.title = `${title} | Payment Source payments`;
  }, [title]);
  return (
    <div
      id="PageTitle"
      role="alert"
      aria-live="assertive"
      className="visually-hidden"
    >
      {title ? `${title} | Payment Source payments` : 'Payment Source payments'}
    </div>
  );
}

export const setPageTitle = (title) => {
  document.title = `${title} | Payment Source payments`;
  const e = document.getElementById('PageTitle');
  if (e) e.textContent = document.title;
};
